export const clientIds = {
  gateway: '2',
  pontoWeb: '3',
  emob: '5',
};
